import useOrderPayPage from "@/viewModels/order-pay/useOrderPayPage";
import SEOMeta from "@/components/ui/meta/SEOMeta";
import { PaymentMethodId } from "@/constants/enums";
import { OrderStatus } from "@/types/order";

const OrderPayPage = () => {
  const { containerRef, order } = useOrderPayPage();

  return (
    <div ref={containerRef} className="brand-text-sm mt-24 text-center text-neutral">
      {order.status === OrderStatus.Pending &&
        order.payment_method === PaymentMethodId.ECPAY_CREDIT &&
        "即將轉往綠界進行付款"}

      {/* Meta Tag */}
      <SEOMeta pageTitle="訂單付款" />
    </div>
  );
};

export default OrderPayPage;
